import { IconProps } from '@abstractTypes/icons'

export const FaceShapeRectangleManIcon: React.FC<IconProps> = ({
  width = '1rem',
  height = '1rem',
  fill = 'none',
  stroke = '#333',
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 49"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke}
    >
      <g clipPath="url(#clip0_1874_61814)">
        <path
          d="M43.6063 22.415C42.9883 21.694 41.9823 21.326 40.4743 21.263L40.7073 19.519C41.1823 15.957 40.6623 12.539 39.2023 9.633C38.5113 8.257 37.6503 7.009 36.6603 5.899C38.1063 4.45 39.0013 2.453 39.0013 0.25H22.0013H21.0013C18.5723 0.25 16.5423 1.991 16.0933 4.291C11.0033 4.751 7.0013 9.042 7.0013 14.25L7.4853 18.25L7.8483 21.254C6.1603 21.276 5.0573 21.644 4.3953 22.414C3.4883 23.471 3.7103 24.923 3.9263 26.328L4.0103 26.89C4.3143 29.025 4.7733 32.25 8.0013 32.25C8.4003 32.25 8.7873 32.193 9.1593 32.095L10.3683 42.093C10.7943 45.603 13.7823 48.25 17.3173 48.25H30.7483C34.2423 48.25 37.2253 45.638 37.6863 42.175L39.0243 32.143C39.3403 32.212 39.6673 32.25 40.0013 32.25C43.2293 32.25 43.6883 29.025 43.9913 26.891L44.0753 26.329C44.2913 24.924 44.5143 23.472 43.6063 22.415ZM30.7483 46.25H17.3173C14.7923 46.25 12.6583 44.359 12.3543 41.852L9.4633 18.002C14.4453 17.697 17.5103 15.819 18.5733 12.363C20.0973 13.825 23.0973 15.25 29.0013 15.25C34.1493 15.25 37.7853 16.318 38.8383 18.114C38.8133 18.491 38.7763 18.871 38.7253 19.254L35.7043 41.911C35.3743 44.385 33.2443 46.25 30.7483 46.25ZM36.6513 2.25C35.8253 4.577 33.6083 6.25 31.0013 6.25V8.25C32.0843 8.25 33.1173 8.031 34.0603 7.639C34.4133 7.492 34.7503 7.316 35.0763 7.122C35.9923 8.128 36.7833 9.269 37.4163 10.53C38.1473 11.987 38.5983 13.601 38.7803 15.305C36.0933 13.566 31.7663 13.25 29.0013 13.25C19.3043 13.25 19.0023 9.268 19.0013 9.25H17.0013C17.0013 12.019 16.1553 15.646 9.2233 16.027L9.0013 14.191C9.0333 9.807 12.6093 6.25 17.0013 6.25H18.0013V5.25C18.0013 3.596 19.3473 2.25 21.0013 2.25H36.6513ZM8.0013 30.25C6.8443 30.25 6.3933 29.434 5.9913 26.609L5.9033 26.024C5.7493 25.023 5.6043 24.076 5.9133 23.717C6.0633 23.542 6.5333 23.25 8.0013 23.25H8.0903L8.9153 30.067C8.6243 30.176 8.3213 30.25 8.0013 30.25ZM42.0993 26.024L42.0113 26.609C41.6093 29.434 41.1583 30.25 40.0013 30.25C39.7553 30.25 39.5203 30.206 39.2913 30.14L40.2093 23.255C41.5053 23.283 41.9463 23.551 42.0893 23.717C42.3973 24.077 42.2523 25.023 42.0993 26.024Z"
          fill="#333333"
        />
        <path d="M26.0153 36.25H21.9883V38.25H26.0153V36.25Z" fill="#333333" />
        <path
          d="M24.4363 31.2496H21.9883V33.2496H26.4363V23.3066H24.4363V31.2496Z"
          fill="#333333"
        />
      </g>
      <defs>
        <clipPath id="clip0_1874_61814">
          <rect width={48} height={48} fill="white" transform="translate(0 0.25)" />
        </clipPath>
      </defs>
    </svg>
  )
}
